import React, { useEffect, useState } from "react";
import Card from "components/Card";
import { StarIcon } from "@heroicons/react/20/solid";
import PageTitle from "components/Title/Page";
import Search from "common/components/Search";
import numeral from "numeral";
import { useSearchParams } from "react-router-dom";
import { ReviewCard } from "common/pages/Clinic/ClinicDetail/ClinicReviewList";
import axios from "axios";
import SpinnerMedium from "components/Spinner/Medium";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";

const LIMIT = 10;

const ReviewList = ({ reviewsExternal = null, filterParams = { offset: 0, limit: 10000 } as any }) => {
    const [reviews, setReviews] = useState(reviewsExternal ?? []);
    const [total, setTotal] = useState(0);
    const [currentOffset, setCurrentOffset] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        console.log("[ReviewList] filterParams", filterParams);
        if (!_.isNil(reviewsExternal)) {
            return;
        }
        setReviews([]);
        setHasMore(true);
        fetchReviews();
    }, [filterParams])

    useEffect(() => {
        console.log("[ReviewList] currentOffset", currentOffset);
        if (_.isNil(currentOffset)) {
            return;
        }
        if (!_.isNil(reviewsExternal)) {
            setHasMore(false);
            return;
        }
        fetchReviews();
    }, [currentOffset])

    const fetchReviews = async () => {
        try {
            const params = {
                ...filterParams,
                offset: currentOffset,
                limit: LIMIT,
            }
            const ret = await axios.get("https://rest.miview.shop/public/reviews", { params });
            console.log("[Review Page] reviews ret", ret.data);
            const newReviews = ret.data.data;
            setTotal(ret.data.total);
            if (newReviews.length === 0) {
                setHasMore(false);
            }
            setReviews((prev) => [...prev, ...newReviews]);
        } catch (e) {
            console.error("[fetchReviews] error", e);
        }
    }

    if (_.isNil(reviews)) {
        return (
            <SpinnerMedium />
        )
    }

    if (total === 0) {
        return (
            <div>
                <div className="text-center text-gray-500 py-10">
                    작성된 리뷰가 없습니다
                </div>
            </div>
        )
    }

    return (
        <InfiniteScroll
            dataLength={reviews.length}
            next={() => setCurrentOffset((prevOffset) => prevOffset + LIMIT)}
            hasMore={hasMore}
            loader={<SpinnerMedium />}
        >
            <div className="px-2 pt-2 text-sm">
                {`${total}건의 리뷰가 검색되었습니다`}
            </div>
            {reviews?.map((item, index) => (
                <div>
                    <Card>
                        <ReviewCard
                            review={item}
                        />
                    </Card>
                </div>
            ))}
        </InfiniteScroll>
    )
}

export default ReviewList;